import { useState, useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { observer, inject } from 'mobx-react'

import SpendDownOffboarding from '../offboarding/spend-down/Dashboard'
import Budget from './budget/Budget'
import Considerations from './considerations/ConsiderationDashboard'
import FinalizeChoices from './finalize-choices/FinalizeChoices'
import SpendDown from './SpendDown'

import { Loading, ErrorPage } from '../../components'

const Dashboard = function (props) {
  const {
    store: {
      setInitialInfoForSpendDown,
      isFirstTimeToSpendDown,
      isSpendDownSet,
      putFirstTimeToSpendDownFalse,
    },
  } = props

  const [status, setStatus] = useState('loading')

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!isSpendDownSet) {
          await setInitialInfoForSpendDown()
        }

        setStatus('success')
      } catch (err) {
        setStatus('error')
        console.error(err)
      }
    }
    fetchData()

    const markFirstTimeAsFalse = async () => {
      try {
        putFirstTimeToSpendDownFalse()
      } catch (err) {
        console.error(err)
      }
    }

    // after component un-mounts we want to set first time to false
    return () => {
      if (isFirstTimeToSpendDown) {
        return markFirstTimeAsFalse()
      }
      return null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (status === 'loading') {
    return <Loading />
  }

  if (status === 'error') {
    return <ErrorPage />
  }

  return (
    <Routes>
      <Route path='/budget' element={<Budget />} />
      <Route path='/considerations/*' element={<Considerations />} />
      <Route path='/finalize-choices' element={<FinalizeChoices />} />
      <Route path='/implement/*' element={<SpendDownOffboarding />} />
      <Route path='/' element={<SpendDown />} />
    </Routes>
  )
}

export default inject('store')(observer(Dashboard))
